import Vue from 'vue'
import App from './app/App.vue'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import VueCookies from 'vue-cookies'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import store from './_store'
import { messages } from './lang/messages'

import VueI18n from 'vue-i18n'
Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(VueCookies)
Vue.config.productionTip = false
Vue.use(VeeValidate, { inject: false })

export const nedasMixin = {
  created: function () {
    let pageTitle = ''
    if (this.$cookies.get('product_name') && this.$cookies.get('product_name').trim() !== '') {
      pageTitle = this.$cookies.get('product_name')
    }
    document.title = pageTitle
  }
}

Vue.mixin(nedasMixin)

export const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages // set locale messages
})

new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
